module.exports = __webpack_public_path__ + "static/media/copy.0112d353.svg";